module.exports = __webpack_public_path__ + "static/media/feature-private3.dfa8cdb6.png";